// extracted by mini-css-extract-plugin
export default {"FreemiumMessage":"_FreemiumMessage--fStLY","Link":"_Link--t_Hcg"};